import * as React from 'react';
import Collapsible from 'react-collapsible';
import '../../misc/Collapsible.scss';
import { FileViewModel, QueryOfFileViewModel, Role, WebPortalClient } from 'webportalclient';
import { MappedServerDirectoryCollapse } from '../DirectoryVisualizer';
import { Column, Table } from "../../Components/QueryTable";

import { Authorization } from '../../misc/components/Authorization';
import { PermissionEnum } from '../../misc/api/ApiPermissionEnum';
import { useCurrentStudyConfigurationContext } from '../../Core/CurrentStudyConfigurationContext';
import { useSecurityContext } from '../../Core/SecurityContext';
import { MatchSortHeader } from '../../Components/MatchSortHeader';
import { ODataParams, Query, useQuery } from '../../Components/Query';

interface DirectoryTableProps {
    roles: Role[];
    directory: MappedServerDirectoryCollapse;
    handleFileDownload: (path: string) => void;
}

export const DirectoryTable = (props: DirectoryTableProps) => {
    const { currentUserPermissions } = useSecurityContext();
    const { study } = useCurrentStudyConfigurationContext();
    const { data, applyFilters, refresh } = useQuery();

    const menuFormatter = (file: FileViewModel) => {
        return (
            <div className="text-center">
                <div className="btn-group" role="group">
                    <button type="button" className="btn btn-primary btn-xs dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                        <i className="fas fa-bars" aria-hidden="true" />
                    </button>
                    <ul className="dropdown-menu pull-right scrollable-menu" role="menu">
                            <li >
                                <a onClick={()=> props.handleFileDownload(file.fullPath)}>Download</a>
                            </li>
                    </ul>
                </div>
            </div>
        );
    };

    return ( data.length === 0 ? null:
        <div className="panel panel-default">
            <div className="panel-body">
                <Table data={data} rowKeyField="name">
                    <Column field="name" header={<MatchSortHeader title="Name" field="name" options={[]} sortField="name" />} formatter={n => n} />
                    <Column field="lastWriteTimeUtc" header={<MatchSortHeader title="Last modified (Server Time)" field="lastWriteTimeUtc" options={[]} sortField="lastWriteTimeUtc" />} formatter={n => n} />
                    <Column field="size" header={<MatchSortHeader title="File Size" field="size" options={[]} sortField="size" />} formatter={n => n} />
                    <Column field="" formatter={menuFormatter} />

                </Table>
            </div>
            <Authorization currentPermissions={currentUserPermissions} studyId={study.id} permissionId={PermissionEnum.MapServerDirectories}>
                {props.roles.length !== 0? 
                    <div className="panel-footer">
                    Shared with roles: {props.directory.userRoles.map(ur => props.roles.find(r => r.id === ur).name).join(", ")}
                    </div> : <></>
                }
            </Authorization>
        </div>
    );
}
